import { useCallback } from "react";

import SEO from "@/components/common/SEO";

import LoanLayout from "@/components/loans/LoanLayout";
import LoanHero from "@/components/loans/LoanHero";
import LoanOverview from "@/components/loans/LoanOverview";
import LoanBenefits from "@/components/loans/LoanBenefits";
import LoanTypes from "@/components/loans/LoanTypes";
import LoanEligibility from "@/components/loans/LoanEligibility";
import LoanDocuments from "@/components/loans/LoanDocuments";
import LoanProcess from "@/components/loans/LoanProcess";
import WhyMoneyMart from "@/components/loans/WhyMoneyMart";
import LoanFAQ from "@/components/loans/LoanFAQ";
import LoanCTA from "@/components/loans/LoanCTA";
import LeadFormSection from "@/components/loans/LeadFormSection";
import PartnerBanks from "@/components/landing/PartnerBanks";

import { LOAN_TYPES } from "@/constants/loanTypes";
import { wealthBasedLoan } from "@/data/loans";

export default function WealthBasedLoan() {
  const scrollToLeadForm = useCallback(() => {
    const el = document.getElementById("lead-form");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return (
    <>
      <SEO {...wealthBasedLoan.seo} />

      <LoanLayout onCtaClick={scrollToLeadForm}>
        <LoanHero
          {...wealthBasedLoan.hero}
          onPrimaryClick={scrollToLeadForm}
          onSecondaryClick={scrollToLeadForm}
        />

        <LoanOverview {...wealthBasedLoan.overview} />

        <LoanBenefits {...wealthBasedLoan.benefits} />

        <LoanTypes {...wealthBasedLoan.types} />

        <LoanEligibility
          {...wealthBasedLoan.eligibility}
          onCheckEligibility={scrollToLeadForm}
        />

        <LoanDocuments {...wealthBasedLoan.documents} />

        <LoanProcess {...wealthBasedLoan.process} />

        <WhyMoneyMart {...wealthBasedLoan.whyMoneyMart} />

        <PartnerBanks />

        <LoanFAQ {...wealthBasedLoan.faq} />

        <LoanCTA {...wealthBasedLoan.cta} onApply={scrollToLeadForm} />

        <LeadFormSection
          {...wealthBasedLoan.leadForm}
          loanType={LOAN_TYPES.WEALTH_BASED_LOAN}
        />
      </LoanLayout>
    </>
  );
}
